export const MONARK_WEBSITE = 'www.leadwithmonark.com'
export const MONARK_CONTACT_EMAIL = 'hello@leadwithmonark.com'
export const MONARK_PRIVACY_POLICY_URL = 'https://www.leadwithmonark.com/privacy-policy/'
export const MONARK_TERMS_URL = 'https://www.leadwithmonark.com/terms-and-conditions/'

export const MONARK_SUPPORT_EMAIL = 'support@leadwithmonark.com'

export const PAGE_TITLE_PREFIX = 'Monark - '

export const PAGE_TITLES = {
  DEFAULT: 'Monark',
  FEEDBACK: PAGE_TITLE_PREFIX + 'Feedback',
  JOURNEY: PAGE_TITLE_PREFIX + 'Journey',
  ADMIN: PAGE_TITLE_PREFIX + 'Admin Dashboard',
  INTERNAL: PAGE_TITLE_PREFIX + 'Internal Dashboard',
  ABOUT: PAGE_TITLE_PREFIX + 'About',
  PRACTISE: PAGE_TITLE_PREFIX + 'Practice'
}

export const ISO_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'english' },
  { value: 'fr', label: 'french' }
]

export const LANGUAGES = { EN: 'en', FR: 'fr' }

export const NARROW_BROWSER_WIDTH = 1160

export const MOBILE = '@media (max-width:899px)'
export const MOBILE_XS = '@media (max-width:450px)'

export const SUMMARY_TABS_ID = 'SummaryTabs'
